/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ReferralsStatistics
 */
export interface ReferralsStatistics {
  /**
   *
   * @type {number}
   * @memberof ReferralsStatistics
   */
  totalMembers?: number
  /**
   *
   * @type {number}
   * @memberof ReferralsStatistics
   */
  totalEarned?: number
  /**
   *
   * @type {number}
   * @memberof ReferralsStatistics
   */
  totalPaidFeesInUsd?: number
  /**
   *
   * @type {number}
   * @memberof ReferralsStatistics
   */
  todayEarnings?: number
  /**
   *
   * @type {number}
   * @memberof ReferralsStatistics
   */
  todayPaidFeesInUsd?: number
}

export function ReferralsStatisticsFromJSON(json: any): ReferralsStatistics {
  return ReferralsStatisticsFromJSONTyped(json, false)
}

export function ReferralsStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralsStatistics {
  if (json === undefined || json === null) {
    return json
  }
  return {
    totalMembers: !exists(json, 'totalMembers') ? undefined : json['totalMembers'],
    totalEarned: !exists(json, 'totalEarned') ? undefined : json['totalEarned'],
    totalPaidFeesInUsd: !exists(json, 'totalPaidFeesInUsd') ? undefined : json['totalPaidFeesInUsd'],
    todayEarnings: !exists(json, 'todayEarnings') ? undefined : json['todayEarnings'],
    todayPaidFeesInUsd: !exists(json, 'todayPaidFeesInUsd') ? undefined : json['todayPaidFeesInUsd'],
  }
}

export function ReferralsStatisticsToJSON(value?: ReferralsStatistics | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    totalMembers: value.totalMembers,
    totalEarned: value.totalEarned,
    totalPaidFeesInUsd: value.totalPaidFeesInUsd,
    todayEarnings: value.todayEarnings,
    todayPaidFeesInUsd: value.todayPaidFeesInUsd,
  }
}
